import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../utils/api';

const initialState = {
  users: [],
  loading: false,
  error: null,
};

export const fetchBDEs = createAsyncThunk(
  'bde/fetchBDEs',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/users?role=bde');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addBDE = createAsyncThunk(
  'bde/addBDE',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post('/users', userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateBDE = createAsyncThunk(
  'bde/updateBDE',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.put(`/users/${userData.id}`, userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteBDE = createAsyncThunk(
  'bde/deleteBDE',
  async (userId, { rejectWithValue }) => {
    try {
      await api.delete(`/users/${userId}`);
      return userId;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const bdeSlice = createSlice({
  name: 'bde',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchBDEs.pending, (state) => { state.loading = true; })
      .addCase(fetchBDEs.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
      })
      .addCase(fetchBDEs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add
      .addCase(addBDE.fulfilled, (state, action) => {
        state.users.push(action.payload);
      })
      // Update
      .addCase(updateBDE.fulfilled, (state, action) => {
        const index = state.users.findIndex(u => u.id === action.payload.id);
        if (index !== -1) state.users[index] = action.payload;
      })
      // Delete
      .addCase(deleteBDE.fulfilled, (state, action) => {
        state.users = state.users.filter(u => u.id !== action.payload);
      });
  },
});

export default bdeSlice.reducer;
